var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#C53434",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3.333 5.147h13.333M7.5 2.5h5M8.333 13.97V8.677m3.333 5.295V8.676m1.25 8.824H7.083c-.92 0-1.667-.79-1.667-1.765l-.38-9.669c-.02-.501.359-.919.832-.919h8.263c.474 0 .852.418.832.92l-.38 9.668c0 .975-.746 1.765-1.667 1.765Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon3);
export default __webpack_public_path__ + "static/media/delete-icon-3.30011ed1276d4bc465fa8cb23700aeb4.svg";
export { ForwardRef as ReactComponent };